const ArrowIcon = ({ height }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="M768 903.232l-50.432 56.768L256 512l461.568-448 50.432 56.768L364.928 512z" />
    </svg>
  );
};

export default ArrowIcon;
